/* Scroll reveal for main-content sections.

   Tagging happens here rather than in Liquid so no section file has to
   change, and so a section that is already on screen at load is revealed
   immediately instead of flashing. Sections carrying sticky or fixed
   descendants are skipped: the transform used for the reveal would make a
   containing block and pin them to the section instead of the viewport. */
(function () {
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sections() {
    var main = document.getElementById('main') || document.querySelector('main');
    if (!main) return [];
    return Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
  }

  function hasPinnedChild(el) {
    var kids = el.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) {
      var pos = getComputedStyle(kids[i]).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
    }
    return false;
  }

  function init() {
    var list = sections();
    if (!list.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      list.forEach(function (el) {
        el.classList.add('ddd-reveal', 'ddd-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ddd-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
    );

    list.forEach(function (el, i) {
      if (hasPinnedChild(el)) return;
      el.classList.add('ddd-reveal');
      // The first screenful should not animate in on load - it is already there.
      if (i === 0 || el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        el.classList.add('ddd-in');
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Pause decorative CSS loops (spinning flowers, marquees, wobbles) while their
   section is off screen. They are infinite and mostly not GPU-composited, so
   left running they recalc style every frame and starve the main thread on
   phones - the hero then paints seconds late. Only CSS animations are paused
   (animation-play-state); JS/Web Animations motion is untouched. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('ddd-paused', !e.isIntersecting); });
    }, { rootMargin: '150px 0px' });
    document.querySelectorAll('.shopify-section, .ddd-hdiv').forEach(function (s) { io.observe(s); });
  }
  // On DOMContentLoaded, not now: ddd-home-skin adds the .ddd-hdiv dividers in its own DOMContentLoaded handler.
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
